import { AppBundleId } from '@inkitt/galatea-common/types/frontend-application/entities';
import { PointsBundle } from '../../types/PointsBundle';

import {
  AUDIOBOOKS_PLUS_TRIAL_OFFERING_KEY,
  audiobooksPlusAllPointsBundles,
  audiobooksPlusTrialPackBundles,
} from './audiobooks-plus.bundles';

import {
  buyFullBook299GalateaBundle,
  buyFullBook499GalateaBundle,
  buyPremiumBook1099Bundle,
  buyPremiumBook1199Bundle,
  buyPremiumBook1299Bundle,
  buyPremiumBook1399Bundle,
  buyPremiumBook1499Bundle,
  buyPremiumBook1599Bundle,
  buyPremiumBook199Bundle,
  buyPremiumBook299Bundle,
  buyPremiumBook399Bundle,
  buyPremiumBook499Bundle,
  buyPremiumBook599Bundle,
  buyPremiumBook699Bundle,
  buyPremiumBook799Bundle,
  buyPremiumBook899Bundle,
  buyPremiumBook999Bundle,
} from './book.bundles';
import {
  galateaStarterPack,
  galateaStarterPackLarge,
  pointsLargeAbandonedCart,
  pointsLargeCountdownDoublePointsOffer,
  pointsLargeUpsell,
  pointsMediumUpsell,
  pointsUpsell550,
} from './non-default.bundles';
import {
  defaultPointsGalateaBiggerPack,
  defaultPointsGalateaBigPack,
  defaultPointsGalateaMediumPack,
  defaultPointsGalateaSmallPack,
  discountedPointsLG,
  discountedPointsMD,
  discountedPointsSM,
  discountedPointsXL,
  discountedPointsXXL,
  discountedPointsXXXL,
  goldenHourPointsSM,
  internationalPointsLG,
  internationalPointsMD,
  internationalPointsSM,
  internationalPointsXL,
  internationalV2PointsLG,
  internationalV2PointsMD,
  internationalV2PointsSM,
  internationalV2PointsXL,
  points110GalateaFor1299,
  points110GalateaFor799,
  points1500GalateaFor3999,
  points1500GalateaFor5999,
  points250GalateaFor1399,
  points250GalateaFor2499,
  points3000GalateaFor6999,
  points3000GalateaFor9999,
  points40GalateaFor399,
  points40GalateaFor799,
  points550GalateaFor2499,
  points550GalateaFor3999,
  pointsLGHigher1,
  pointsLGLower1,
  pointsMDHigher1,
  pointsMDLower1,
  pointsSMHigher1,
  pointsSMLower1,
  pointsXLHigher1,
  pointsXLLower1,
} from './points.bundles';
import { applyMostPopular, applyRecommended } from './utils';

const galateaPartnerBooksPurchaseBundles: PointsBundle[] = [
  buyPremiumBook199Bundle,
  buyPremiumBook299Bundle,
  buyPremiumBook399Bundle,
  buyPremiumBook499Bundle,
  buyPremiumBook599Bundle,
  buyPremiumBook699Bundle,
  buyPremiumBook799Bundle,
  buyPremiumBook899Bundle,
  buyPremiumBook999Bundle,
  buyPremiumBook1099Bundle,
  buyPremiumBook1199Bundle,
  buyPremiumBook1299Bundle,
  buyPremiumBook1399Bundle,
  buyPremiumBook1499Bundle,
  buyPremiumBook1599Bundle,
];

const nonDefaultBundles: PointsBundle[] = [
  galateaStarterPack,
  galateaStarterPackLarge,
  buyFullBook299GalateaBundle,
  buyFullBook499GalateaBundle,
  ...galateaPartnerBooksPurchaseBundles,
];

// need all bundles for backward compatibility, don't use it for any new test variant
export const galateaAllOneTimePurchaseBundles: PointsBundle[] = [
  defaultPointsGalateaSmallPack,
  applyRecommended(defaultPointsGalateaMediumPack),
  defaultPointsGalateaBigPack,
  defaultPointsGalateaBiggerPack,
  ...nonDefaultBundles,
];

export const galateaAllOneTimePurchaseBundlesWithCountdownOffer: PointsBundle[] = [
  {
    ...pointsLargeCountdownDoublePointsOffer,
    offerDetails: {
      type: 'countdownOffer',
      config: {
        basePoints: defaultPointsGalateaBigPack.tiers,
        maxTimesAllowedPurchase: 1,
        daysToShowOffer: 3,
        minUniqueCountdownViews: 7,
        offerShowPerDay: 1,
      },
    },
  },
  pointsUpsell550,
  ...galateaAllOneTimePurchaseBundles,
];

export const galateaAllOneTimePurchaseBundlesWithUpsellAndAbandon = [
  pointsMediumUpsell,
  pointsLargeAbandonedCart,
  ...galateaAllOneTimePurchaseBundles,
];

export const pricingV1FourPack: PointsBundle[] = [
  points40GalateaFor399,
  points110GalateaFor799,
  points250GalateaFor1399,
  points550GalateaFor2499,
  ...galateaPartnerBooksPurchaseBundles,
];

export const pricingV2FourPack: PointsBundle[] = [
  points40GalateaFor799,
  points110GalateaFor1299,
  points250GalateaFor2499,
  points550GalateaFor3999,
  ...galateaPartnerBooksPurchaseBundles,
];

export const pricingV3SixPack: PointsBundle[] = [
  defaultPointsGalateaSmallPack,
  defaultPointsGalateaMediumPack,
  defaultPointsGalateaBigPack,
  defaultPointsGalateaBiggerPack,
  points1500GalateaFor3999,
  points3000GalateaFor6999,
  ...galateaPartnerBooksPurchaseBundles,
];

export const pricingV4SixPack: PointsBundle[] = [
  points40GalateaFor399,
  points110GalateaFor799,
  points250GalateaFor1399,
  points550GalateaFor2499,
  points1500GalateaFor5999,
  points3000GalateaFor9999,
  ...galateaPartnerBooksPurchaseBundles,
];

export const galateaBigBundleRecommended: PointsBundle[] = [
  defaultPointsGalateaSmallPack,
  defaultPointsGalateaMediumPack,
  applyRecommended(defaultPointsGalateaBigPack),
  defaultPointsGalateaBiggerPack,
  ...galateaPartnerBooksPurchaseBundles,
];

export const galateaBiggerBundleRecommended: PointsBundle[] = [
  defaultPointsGalateaSmallPack,
  defaultPointsGalateaMediumPack,
  defaultPointsGalateaBigPack,
  applyRecommended(defaultPointsGalateaBiggerPack),
  ...galateaPartnerBooksPurchaseBundles,
];

export const galateaBiggerRecommendedBigMostPopular: PointsBundle[] = [
  defaultPointsGalateaSmallPack,
  defaultPointsGalateaMediumPack,
  applyMostPopular(defaultPointsGalateaBigPack),
  applyRecommended(defaultPointsGalateaBiggerPack),
  ...galateaPartnerBooksPurchaseBundles,
];

// all packages are same as galateaAllOneTimePurchaseBundles but cheapest one is higher
export const higherCheapest: PointsBundle[] = [
  points40GalateaFor399,
  defaultPointsGalateaMediumPack,
  defaultPointsGalateaBigPack,
  defaultPointsGalateaBiggerPack,
  ...galateaPartnerBooksPurchaseBundles,
];

export const higher1Packages: PointsBundle[] = [
  pointsSMHigher1,
  applyRecommended(pointsMDHigher1),
  pointsLGHigher1,
  pointsXLHigher1,
  ...galateaPartnerBooksPurchaseBundles,
];

export const higherSmallPackage: PointsBundle[] = [
  pointsSMHigher1,
  defaultPointsGalateaMediumPack,
  defaultPointsGalateaBigPack,
  defaultPointsGalateaBiggerPack,
  galateaStarterPack,
  galateaStarterPackLarge,
  ...galateaPartnerBooksPurchaseBundles,
];

export const lower1Packages: PointsBundle[] = [
  pointsSMLower1,
  applyRecommended(pointsMDLower1),
  pointsLGLower1,
  pointsXLLower1,
];

export const galateaDiscountPurchaseBundles: PointsBundle[] = [
  discountedPointsSM,
  discountedPointsMD,
  discountedPointsLG,
  discountedPointsXL,
  discountedPointsXXL,
  discountedPointsXXXL,
];

export const galateaBundlesWithUpsellMedium: PointsBundle[] = [pointsMediumUpsell, ...galateaAllOneTimePurchaseBundles];

export const galateaBundlesWithUpsellLarge: PointsBundle[] = [pointsLargeUpsell, ...galateaAllOneTimePurchaseBundles];

export const galateaBundlesWithCartAbandonLarge: PointsBundle[] = [
  pointsLargeAbandonedCart,
  ...galateaAllOneTimePurchaseBundles,
];

const withCountdownDoublePointsOffers = (bundles: PointsBundle[]): PointsBundle[] => {
  return [
    ...bundles,
    {
      ...pointsLargeCountdownDoublePointsOffer,
      offerDetails: {
        type: 'countdownOffer',
        config: {
          basePoints: defaultPointsGalateaBigPack.tiers,
          maxTimesAllowedPurchase: 1,
          daysToShowOffer: 3,
          minUniqueCountdownViews: 7,
          offerShowPerDay: 1,
        },
      },
    },
  ];
};

const withAllNonDefaultBundles = (bundles: PointsBundle[]): PointsBundle[] => {
  return [...bundles, ...nonDefaultBundles];
};

export const withBundlePrefixed = (bundles: PointsBundle[], prefix: string) => {
  return bundles.map((bundle) => ({
    ...bundle,
    id: `${prefix}${bundle.id}`,
  }));
};

export const internationalPointsOffer = withAllNonDefaultBundles(
  withCountdownDoublePointsOffers([
    internationalPointsSM,
    internationalPointsMD,
    internationalPointsLG,
    internationalPointsXL,
  ]),
);

export const internationalV2PointsOffer = withAllNonDefaultBundles(
  withCountdownDoublePointsOffers([
    internationalV2PointsSM,
    internationalV2PointsMD,
    internationalV2PointsLG,
    internationalV2PointsXL,
  ]),
);

export const galateaPointsBundlesGroup: Record<string, PointsBundle[]> = {
  default: galateaAllOneTimePurchaseBundlesWithCountdownOffer,
  yearly_baseline_with_family_plan: galateaAllOneTimePurchaseBundlesWithCountdownOffer,
  golden_hour_intro_offer: [...galateaAllOneTimePurchaseBundlesWithCountdownOffer, goldenHourPointsSM],
  defaultWithUpsellAndAbandon: galateaAllOneTimePurchaseBundlesWithUpsellAndAbandon,
  organic_discounted: withAllNonDefaultBundles(
    withCountdownDoublePointsOffers([discountedPointsSM, discountedPointsMD, discountedPointsLG, discountedPointsXL]),
  ),
  yearly_unlimited_international: internationalPointsOffer,
  'unlimited.3m_1y_international': internationalPointsOffer,
  family_international_baseline: internationalPointsOffer,
  ifp_v2_points: internationalV2PointsOffer,
  family_international_v2: internationalV2PointsOffer,
};

export const galateaQAPointsBundlesGroup = {
  default: withBundlePrefixed(galateaAllOneTimePurchaseBundlesWithCountdownOffer, 'qa.'),
};

// Audiobooks Plus has no subscriptions and no pricing tests, so a single group is enough. Its key
// must match the brand's RevenueCat offering name, since the client intersects this catalogue with
// the offering looked up under the same key.
export const audiobooksPlusPointsBundlesGroup: Record<string, PointsBundle[]> = {
  default: audiobooksPlusAllPointsBundles,
  // The trial pack is served under its own key so that only a client asking for it can resolve it;
  // every build that asks for `default` — which is every build shipped so far — cannot see it.
  [AUDIOBOOKS_PLUS_TRIAL_OFFERING_KEY]: audiobooksPlusTrialPackBundles,
};

// Store bundle ids, not `AppBundleId`. Root pins `@inkitt/galatea-common` 1.1.0, which adds
// AudiobooksPlusIOS/Android with these same string values. `Partial<Record<AppBundleId, …>>`
// then rejects the literal keys (TS2353) because string-enum Records only accept
// `[AppBundleId.…]` computed keys. Local node_modules is often still 1.0.451 (no those
// members), so the same literals type-check here and only fail on a clean CI install.
// Runtime keys must stay these strings on both versions — iOS keeps the original id;
// Android uses `…audiobooksplus` (Play package was burned).
export const pointsBundles: Record<string, Record<string, PointsBundle[]>> = {
  // Galatea QA App
  [AppBundleId.GalateaQA]: galateaQAPointsBundlesGroup,

  // Galatea App
  [AppBundleId.GalateaIOS]: galateaPointsBundlesGroup,
  [AppBundleId.GalateaAndroid]: galateaPointsBundlesGroup,

  // Audiobooks Plus — falls back to Galatea's catalogue without these entries, which would offer
  // products this app cannot sell (see getPointsMapForApplicationBundleId in saturn).
  'com.inkitt.galatea.audiobooks': audiobooksPlusPointsBundlesGroup,
  'com.inkitt.galatea.audiobooksplus': audiobooksPlusPointsBundlesGroup,
};

export * from './all-points.bundles';
export * from './points.bundles';
export * from './non-default.bundles';
export * from './audiobooks-plus.bundles';
